/* global gsap, ScrollTrigger */
import { $, addAction, INIT } from '@situation/setdesign.util';

addAction(INIT, () => {
    // Initialize GSAP and ScrollTrigger
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);
        // Animate hero trees - initial slide down from top to bottom
        const $bgImages = $('.hero-202603 .content-background-image__img--desktop');
        if ($bgImages.length) {
            const treesElement = $bgImages[0];
            // Initial animation: slide down from top to bottom of viewport
            gsap.fromTo(
                treesElement,
                { y: 0 },
                {
                    y: 100,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: '.hero-202603',
                        start: 'top top',
                        end: 'bottom top',
                        scrub: 1,
                        invalidateOnRefresh: true,
                    },
                },
            );
        }
    }
});
// EXAMPLE OF HOW TO USE:
// const easeOutExpo = (x) => (x === 1 ? 1 : 1 - 2 ** (-10 * x));
// const maxTime = 1000;
// const easeRate = 20;
// /* eslint-disable no-param-reassign */
// const processBatch = (batch, add) => {
//     window.requestAnimationFrame(() => {
//         batch.forEach((element, index) => {
//             if (add) {
//                 const delay = Math.round(maxTime * easeOutExpo(index / easeRate)) + 200;
//                 if (delay) {
//                     element.style.transitionDelay = `${delay}ms`;
//                 }
//                 element.classList.add('animate-to');
//                 element.classList.remove('animate-from');
//             } else {
//                 element.style.transitionDelay = '';
//                 element.classList.add('animate-from');
//                 element.classList.remove('animate-to');
//             }
//         });
//     });
// };
// const forceUpdate = () => {
//     setTimeout(() => {
//         window.requestAnimationFrame(() => {
//             ScrollTrigger.refresh(false);
//             ScrollTrigger.update();
//         });
//     }, 0);
// };
// /* eslint-enable no-param-reassign */
// const selectors = ['.content-section__container'];
// addAction(INIT, () => {
//     $(selectors.join(', ')).addClass('animate-from');
//     ScrollTrigger.batch(selectors.join(', '), {
//         onEnter: (batch) => processBatch(batch, true),
//         // onLeave: (batch) => processBatch(batch, false),
//         // onEnterBack: (batch) => processBatch(batch, true),
//         onLeaveBack: (batch) => processBatch(batch, false),
//     });
//     addAction('updateScrollTrigger', forceUpdate);
//     addAction(HASH_STATE_CHANGE, forceUpdate);
//     addAction('toggleTrigger', ($targets) => {
//         const elements = $targets
//             .find('.animate-to')
//             .filter((i, el) => SetDesign.viewport.isInViewport(el))
//             .get();
//         if (elements.length) {
//             processBatch(elements, false);
//             window.requestAnimationFrame(() => {
//                 processBatch(elements, true);
//             });
//         }
//     });
// });
